import { set } from '../storeHelpers';

const state = {
  progress: 3,
  totalSteps: 6,
  progressShow: false,
};

const actions = {
  progress({commit}, data) {
    commit('progress', data);
  },
  totalSteps({commit}, data) {
    commit('totalSteps', data);
  }
};

const mutations = {
  progress: set('progress'),
  totalSteps: set('totalSteps'),
  progressShow: set('progressShow'),
};

const getters = {
  progress(state) {
    return state.progress;
  },
  totalSteps(state) {
    return state.totalSteps;
  },
  progressShow(state) {
    return state.progressShow;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
